import React, { useEffect, useState } from 'react'
import "../newAbout/Team.css"
import LandingPageContact from '../LandingPage/LandingPageContact.js'
import Lorik from '../images/Lorik.png'
import Denis from '../images/Denis.png'
import Bleron from '../images/Bleron.png'

function FullTeam() {
  const [itemData, setItemData] = useState([]);
  useEffect(() => {
    // Fetch or update the item data here
    // For demonstration purposes, I'll initialize the data directly
    const itemData = [
      {
        image: require('../images/erza.jpg'),
        position: "HR",
        colorposition: "#E92269",
        name: "Ereza Aruqaj",
        fullposition: "Human Resources",
      },
      {
        image: "https://res.cloudinary.com/dr5bzig6k/image/upload/v1688391284/kutiza/Team/Gresa_tktn4g.svg",
        position: "UI UX",
        colorposition: "#E92269",
        name: "Gresa Bytyqi",
        fullposition: "UI/UX Designer",
      },
      {
        image: "https://res.cloudinary.com/dr5bzig6k/image/upload/v1695632750/kutiza/Team/Group_427319556_zbbbgc.png",
        position: "Back-End",
        colorposition: "#35A0DC",
        name: "Albenit Bytyqi",
        fullposition: "Back-End Developer",
      },
      {
        image: "https://res.cloudinary.com/dr5bzig6k/image/upload/v1695632750/kutiza/Team/Group_427319555_z93dxv.png",
        position: "Front-End",
        colorposition: "#00CF98",
        name: "Flori Frrokaj",
        fullposition: "Front End Developer",
      },


      {
        image: Lorik,
        position: "Back-End",
        colorposition: "#35A0DC",
        name: "Lorik Aliu",
        fullposition: "Back-End Developer",
      },

      {
        image: Denis,
        position: "Design",
        colorposition: "#6665DD",
        name: "Denis Demolli",
        fullposition: "Social Media Manager",
      },
      {
        image: Bleron,
        position: "Back-End",
        colorposition: "#6665DD",
        name: "Bleron Mexhuani",
        fullposition: "Back End Developer",
      },
      {
        image: "https://res.cloudinary.com/dr5bzig6k/image/upload/v1688391286/kutiza/Team/Drin2_czz4u8.svg",
        position: "Marketing",
        colorposition: "#F7D34E",
        name: "Drin Arifi",
        fullposition: "Digital Marketing Lead",
      },
      {
        image: "https://res.cloudinary.com/dr5bzig6k/image/upload/v1688391296/kutiza/Team/Ardit_eqjz0f.svg",
        position: "Front-End",
        colorposition: "#E92269",
        name: "Ardit Zogjani",
        fullposition: "Front End Developer ",
      },

    ];
    setItemData(itemData)


  }, []);
  return (
    <>
      <div className='container-md px-4 px-lg-5'>
        <div className="containerofspace ">
          <div className="maintittleee servicesTitle pt-5 pt-md-0" style={{ color: "black", paddingBottom: "2rem" }}>
            <span className='maintittleee pt-0'> Meet Our Team Members</span>
          </div>
          <div className="row g-4 g-md-3 g-xxl-4 justify-content-center">

            {itemData.map((item) => (
              <div className="col-12 col-sm-6 col-lg-4 col-xxl-3" key={item.image}>
                <div className="teamswiper h-100" style={{ position: 'relative' }}>
                  <div className="Figure h-100">
                    <div className="teamMemberInfo " style={{ background: item.colorposition }}>{item.position}</div>
                    <img
                      className="w-100 h-100"
                      src={item.image}
                      style={{ objectFit: 'cover' }}
                      alt="Team Member"
                    />
                    <div className=" teamMemberInfo2">
                      <div className="theorderof2">
                        <p className="nameofteammember" style={{ color: item.colorposition }}>{item.name}</p>
                        <div className="" style={{ display: "flex" }}>
                          <p className="positionofteammember mb-0" style={{ fontWeight: "700" }}>{item.fullposition}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

        </div>
        <div className="containerofspace"></div>
      </div>
      <div className=''>
        <LandingPageContact />
      </div>
    </>
  )
}

export default FullTeam